// src/shared/components/Header/index.js
import React, { useRef, useEffect, useState } from 'react';
import { Navbar, Nav, Container, Image } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../../contexts/ThemeContext';
import './styles.css';

const Header = () => {
    const { theme, toggleTheme } = useTheme();
    const { isAuthenticated, logout, user } = useAuth();
    const [expanded, setExpanded] = useState(false);
    const navbarRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navbarRef.current && !navbarRef.current.contains(event.target) && expanded) {
                setExpanded(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [expanded]);

    const handleLogout = () => {
        logout();
        setExpanded(false);
    };

    const handleNavClick = () => {
        setExpanded(false);
    };

    const getThemeIconPath = () => {
        return theme === 'dark' ? '/theme/dark_mode.png' : '/theme/light_mode.png';
    };

    return (
        <Navbar expand="lg" expanded={expanded} onToggle={setExpanded} ref={navbarRef}>
            <Container>
                <Navbar.Brand as={NavLink} to="/" onClick={handleNavClick}>
                    <Image src="/logo512.png" width="25" className="mr-2 logo-image" />
                    FitOps
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav" className="justify-content-between">
                    <Nav className="mr-auto">
                        {isAuthenticated && (
                            <>
                                <Nav.Link as={NavLink} to="/fithub" onClick={handleNavClick}>FitHub</Nav.Link>
                                <Nav.Link as={NavLink} to="/competitions" onClick={handleNavClick}>Competitions</Nav.Link>
                                <Nav.Link as={NavLink} to="/activities" onClick={handleNavClick}>Recent Activities</Nav.Link>
                                {/* <Nav.Link as={NavLink} to="/statistics">Statistics</Nav.Link> */}
                            </>
                        )}
                        <Nav.Link as={NavLink} to="/rules" onClick={handleNavClick}>Rules</Nav.Link>
                    </Nav>
                    <Nav>
                        <Nav.Link onClick={() => { toggleTheme(); handleNavClick(); }}>
                            <Image src={getThemeIconPath()} width="25" alt="Theme toggle" />
                        </Nav.Link>
                        {user && <Nav.Link as={NavLink} to="/activity" onClick={handleNavClick}>Register Activity</Nav.Link>}
                        {user && <Nav.Link as={NavLink} to={`/profile/${user.Username}`} onClick={handleNavClick}>My Profile</Nav.Link>}
                        {isAuthenticated ? (
                            <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
                        ) : (
                            <Nav.Link as={NavLink} to="/login" onClick={handleNavClick}>Login</Nav.Link>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;
